import React from 'react';
import PropTypes from 'prop-types';
import {
  View, // ScrollView,
} from 'react-native';
import { ScrollView } from 'react-native-web';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { ViewPropTypes } from 'deprecated-react-native-prop-types'
import LinearGradient from 'react-native-linear-gradient';

class ScrollFading extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.onScroll = this.onScroll.bind(this);

    this.elementTopOpacity = 0.0;
    this.elementBottomOpacity = 1.0;
  }

  onScroll(e) {
    const {
      horizontal,
    } = this.props;
    const {
      contentOffset, contentSize, layoutMeasurement,
    } = e.nativeEvent;

    let deltaTop = horizontal ? contentOffset.x : contentOffset.y;
    let deltaBottom = horizontal
      ? contentSize.width - layoutMeasurement.width - contentOffset.x
      : contentSize.height - layoutMeasurement.height - contentOffset.y;

    deltaTop = Number.parseFloat(deltaTop);
    deltaBottom = Number.parseFloat(deltaBottom);

    if (deltaTop > 50.0) {
      deltaTop = 50.0;
    }
    if (deltaTop < 0.0) {
      deltaTop = 0.0;
    }
    if (deltaBottom > 50.0) {
      deltaBottom = 50.0;
    }
    if (deltaBottom < 0.0) {
      deltaBottom = 0.0;
    }

    const opacityTop = deltaTop / 50.0;
    const opacityBottom = deltaBottom / 50.0;

    if (this.gradientTop && this.elementTopOpacity !== opacityTop) {
      this.elementTopOpacity = opacityTop;
      // console.log('opacityTop: ', opacityTop, 'gradient: ', this.gradientTop);
      this.gradientTop.props.style[1].opacity = opacityTop;
      this.gradientTop.forceUpdate();
    }

    if (this.gradientBottom && this.elementBottomOpacity !== opacityBottom) {
      this.elementBottomOpacity = opacityBottom;
      // console.log('opacityBottom: ', opacityBottom, 'gradient: ', this.gradientBottom);
      this.gradientBottom.props.style[0].opacity = opacityBottom;
      this.gradientBottom.forceUpdate();
    }
  }

  render() {
    const {
      style,
      containerStyle,
      contentContainerStyle,
      horizontal,
      color,
      children,
      scrollRef,
      ...otherProps
    } = this.props;

    return (
      <View
        style={[
          {
            flex: 1,
            width: style.width,
          },
          containerStyle,
        ]}
      >
        {/* <KeyboardAwareScrollView
          behavior="padding" */}
        <ScrollView
          ref={scrollRef}
          {...otherProps} // eslint-disable-line react/jsx-props-no-spreading
          onScroll={this.onScroll}
          scrollEventThrottle={16}
          style={style}
          contentContainerStyle={contentContainerStyle}
          horizontal={horizontal}
          useNativeDriver
        >
          {children}
        </ScrollView>
        {/* </KeyboardAwareScrollView> */}

        <LinearGradient
          style={[{
            position: 'absolute',
            opacity: 0.0,
          }, horizontal ? {
            left: 0,
            width: '20%',
            height: '100%',
          } : {
            top: 0,
            width: '100%',
            height: '20%',
          }]}
          colors={[`${color}f`, `${color}0`]}
          pointerEvents="none"
          ref={(gradientTop) => { this.gradientTop = gradientTop; }}
        />
        <LinearGradient
          start={{ x: 0, y: 0 }}
          end={{
            x: horizontal ? 1 : 0,
            y: horizontal ? 0 : 1,
          }}
          style={[{
            position: 'absolute',
            opacity: 1.0,
          }, horizontal ? {
            right: 0,
            width: '20%',
            height: '100%',
          } : {
            bottom: 0,
            width: '100%',
            height: '20%',
          }]}
          colors={[`${color}0`, `${color}f`]}
          pointerEvents="none"
          ref={(gradientBottom) => { this.gradientBottom = gradientBottom; }}
        />
      </View>
    );
  }
}

ScrollFading.defaultProps = {
  style: {},
  containerStyle: {},
  contentContainerStyle: {},
  horizontal: false,
  color: '#fff',
  children: undefined,
  refreshControl: undefined,
  scrollRef: undefined,
};

ScrollFading.propTypes = {
  style: ViewPropTypes.style,
  containerStyle: ViewPropTypes.style,
  contentContainerStyle: ViewPropTypes.style,
  color: PropTypes.string,
  horizontal: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  refreshControl: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
  ]),
  scrollRef: PropTypes.func,
};

export default ScrollFading;
